import _ from "lodash";
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import API from "../app/api";
import {user} from "../store/reducers/user";

export default function useCliniciansAndNursesDict(type, cliniciansOnly = false) {
    const controller = new AbortController();
    const userObject = useSelector(user);

    const [list, setList] = useState([]);
    const [findUser, setFindUser] = useState(null);

    useEffect(async () => {
        const consultantTypeFilter = type ? `${type} eq true and `  : '';
        const tempList = [];

        await API.getDictByURL(`/$dict/Clinicians?$filter=${encodeURIComponent(`(${consultantTypeFilter}deactivated ne true)`)}&$sort=description`, controller.signal)
            .then(dictData => {
                if (!_.isEmpty(dictData?.__data)) {
                    _.forEach(dictData?.__data, element => {
                        if (element.userName === userObject?.userName) {
                            setFindUser(element);
                        }

                        tempList.push({
                            ...element,
                            group: "Clinicians"
                        });
                    });
                }
            });

        if (!cliniciansOnly) {
            await API.getDictByURL(`/$dict/Nurses?$filter=${encodeURIComponent(`(${consultantTypeFilter}deactivated ne true)`)}&$sort=description`, controller.signal)
                .then(dictData => {
                    if (!_.isEmpty(dictData?.__data)) {
                        _.forEach(dictData?.__data, element => {
                            if (element.userName === userObject?.userName) {
                                setFindUser(element);
                            }

                            tempList.push({
                                ...element,
                                group: "Nurses"
                            });
                        });
                    }
                });
        }

        setList(tempList);

        return () => {
            controller.abort();
        };
    }, []);

    return [list, findUser];
}